import React, { useContext } from "react";
import S from "./FundInfo";
import CardHeader from "../CardHeader";
import FundContext from "@/components/FundSingle/FundProvider";
import moment from "moment";
import Table from "../../../Table/index";

const FundInfo: React.FC<FundSingle> = () => {
  const { fundRiskDetails, outputPercentage } = useContext(FundContext);

  if (!fundRiskDetails) return null;

  var tableValues = {};

  // Facts
  const morningstarCategory = fundRiskDetails.Benchmark.find(
    (b) => b.Type == "Category"
  ).Name;
  const ISIN = fundRiskDetails.Isin;
  const formattedNAV =
    "SEK " +
    new Intl.NumberFormat("sv-SE").format(fundRiskDetails.LastPrice.Value);
  const formattedChangeOneDay = outputPercentage(
    fundRiskDetails.TrailingPerformance.find(
      (tp) => tp.ReturnType == "Nav"
    ).Return.find((r) => r.TimePeriod == "D1").Value
  );
  const dividendFrequency = fundRiskDetails.DividendDistributionFrequency;
  const formattedTotalMarketValue =
    new Intl.NumberFormat("sv-SE").format(
      fundRiskDetails.FundNetAssetValues[0].MonthEndValue / 1000000
    ) + " SEK";
  const kidOngoingCosts = outputPercentage(
    fundRiskDetails.KID.OngoingCostsOtherCosts
  );
  const resultFee = fundRiskDetails.PerformanceFee;
  const purchaseFee = outputPercentage(
    fundRiskDetails.PurchaseDetails[0].FrontLoad.Value
  );
  const sellFee = outputPercentage(
    fundRiskDetails.PurchaseDetails[0].DeferLoad.Value
  );
  const managerName =
    fundRiskDetails.ManagerList[0].GivenName +
    " " +
    fundRiskDetails.ManagerList[0].FamilyName;
  const startYear = moment(fundRiskDetails.InceptionDate).format("YYYY-MM-DD");
  const totalMarketValueDate =
    fundRiskDetails.FundNetAssetValues[0].MonthEndDate;
  const NAV = fundRiskDetails.LastPrice.Value;
  const NAVDate = fundRiskDetails.LastPrice.Date;

  fundRiskDetails.DividendFrequency = dividendFrequency;

  // Populate tableValues
  function addToTable(label, value) {
    tableValues[label] = [value];
  }

  addToTable("Morningstar-kategori", morningstarCategory);
  addToTable("ISIN", ISIN);
  addToTable(
    "Senaste NAV " + moment(NAVDate).format("YYYY-MM-DD"),
    formattedNAV
  );
  addToTable("Ändring en dag", formattedChangeOneDay);
  addToTable("Utdelningsfrekvens", dividendFrequency);
  addToTable(
    "Fondförmögenhet (milj) " +
      moment(totalMarketValueDate).format("YYYY-MM-DD"),
    formattedTotalMarketValue
  );
  addToTable("KID avgift övriga kostnader", kidOngoingCosts);
  addToTable("Resultatbaserad Avgift %", resultFee);
  addToTable("Köp", purchaseFee);
  addToTable("Sälj", sellFee);
  addToTable("Namn", managerName);
  addToTable("Fondens startår", startYear);

  var tableData = {
    headings: ["Fondfakta", ""],
    rows: tableValues,
  };

  return (
    <S.AllocationWrapper>
      <CardHeader title="Fondfakta" />
      <Table tableData={tableData} showIndexInfo={true} />
    </S.AllocationWrapper>
  );
};

export default FundInfo;
